import { ApiBase } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { EventEntity } from '../event/event-entity';
import { GroupEntity } from '../group/group-entity';
import { VenueEntity } from '../venue/venue-entity';
import { EventCommentEntity } from '../event/event-comment-entity';
import { ScheduleEntity } from '../schedule/schedule-entity';
import { SerieSettingEntity } from '../serie/serie-setting-entity';
import { CustomIntervalEntity } from '../custom-interval/custom-interval-entity';
import { TeamSettingEntity } from '../team/team-setting-entity';
import { ScheduleFieldEntity } from '../schedule/schedule-field-entity';
import { MapEventEntity } from '../event/map-event-entity';
import { Sport } from '../event/sport';

export interface SchedulePresentationEntity {
    schedule: ScheduleEntity;
    serie: SerieSettingEntity;
    customIntervals: CustomIntervalEntity[];
    teams: TeamSettingEntity[];
    fields: ScheduleFieldEntity[];
}

export interface EventPresentationEntity {
    event: EventEntity;
    groups: GroupEntity[];
    venues: VenueEntity[];
    comments: EventCommentEntity[];
    schedules: SchedulePresentationEntity[];
}

// Single anonymous read backing the present and registration pages — see PresentController.
@inject(IHttpClient)
export class PresentApi extends ApiBase {
    private _baseUrl: string = 'api/present';

    constructor(http: IHttpClient) {
        super(http);
    }

    public async getByCode(code: string): Promise<EventPresentationEntity> {
        const response = await this.get(`${this._baseUrl}/${encodeURIComponent(code)}`);
        const dto = response.content;
        return {
            event: EventEntity.fromDto(dto),
            groups: GroupEntity.fromDtoArray(dto.groups),
            venues: VenueEntity.fromDtoArray(dto.venues),
            comments: EventCommentEntity.fromDtoArray(dto.comments),
            schedules: (dto.schedules ?? []).map((s: any) => ({
                schedule: ScheduleEntity.fromDto(s),
                serie: SerieSettingEntity.fromDto(s.serie),
                customIntervals: CustomIntervalEntity.fromDtoArray(s.customIntervals),
                teams: TeamSettingEntity.fromDtoArray(s.teams),
                fields: ScheduleFieldEntity.fromDtoArray(s.fields),
            })),
        };
    }

    public async getMapEvents(from?: string, to?: string, search?: string, sport?: Sport): Promise<MapEventEntity[]> {
        const response = await this.get(`${this._baseUrl}/map`, { from, to, search, sport });
        return MapEventEntity.fromDtoArray(response.content);
    }
}
